<template>
  <a-modal
    v-model="visible"
    title="选择服务"
    width="716px"
    :destroyOnClose="true"
    :bodyStyle="{ padding: 0 }"
    :ok-button-props="{ props: { shape: 'round', loading: buttonLoading } }"
    :cancel-button-props="{ props: { shape: 'round' } }"
    @ok="handleOk"
    @cancel="selected = null"
  >
    <a-row style="padding:24px">
      <a-form-model class="ant-advanced-search-form">
        <a-col :lg="10" :md="12" :sm="24">
          <a-form-model-item label="搜索">
            <a-input-search
              v-model="name"
              allowClear
              placeholder="请输入服务名称"
              style="width: 100%"
              @search="initData"
            />
          </a-form-model-item>
        </a-col>
      </a-form-model>
    </a-row>

    <service-table ref="table" @change="e => (selected = e)"></service-table>
  </a-modal>
</template>

<script>
import ServiceTable from './ServiceTable'

export default {
  components: {
    ServiceTable
  },
  data() {
    return {
      visible: false,
      buttonLoading: false,
      name: '',
      selected: null
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.initData()
    },
    initData() {
      const { $nextTick, name, $refs } = this

      $nextTick(() => {
        $refs.table.initData({ name })
      })
    },
    handleOk() {
      const { selected } = this

      if (selected) {
        this.visible = false
        this.$emit('submit', selected)
      } else {
        this.$emit('submit', null)
        this.visible = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ant-advanced-search-form /deep/ .ant-form-item {
  display: flex;
  margin-bottom: 0;
}
.ant-advanced-search-form /deep/ .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
